// extracted by mini-css-extract-plugin
module.exports = {"label":"fieldLabel_label__1-JBK","required":"fieldLabel_required__26eOr"};